import React from "react";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <div className="page">
      <section className="section section-light">
        <div className="section-inner">
          <h2>Page Not Found</h2>
          <p>
            Oops! That page doesn&apos;t seem to exist.{" "}
            <Link to="/">Return home</Link>.
          </p>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
